import '../delay_render_chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.SingleDimensionView extends CustomerVisualMode.Charts.DelayRenderChartView
  className: 'grid-item single-dimension full-width-chart'
  template: JST['backbone/templates/customer_visual_mode/charts/single_dimension_chart']
  @NAME: 'single_dimension_chart'

  CHART_TYPE = Common.Dashboard.Widget.ChartType

  initialize: ({widget, data, barMenu, dataFormatter, nameTranslator, valueTranslator, chartView, sortDropdown, session, isReadOnly, isResponsive}) ->
    @widget = widget
    @chartView = chartView
    @nameTranslator = nameTranslator
    @valueTranslator = valueTranslator
    @data = data
    @barMenu = barMenu
    @dataFormatter = dataFormatter
    @barMenu.customOptionViews.map((view) => @listenTo(view, view.toggleEventName, view.getToggleMethod(@)))
    @sortDropdown = sortDropdown
    @listenTo(@sortDropdown, 'change', @_changeSorting) if @sortDropdown
    super({widget, title: @_getTitle(), description: @_getDescription(), data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @_setChartWidth()
    @listenTo(@chartView, 'singledimension:click', @_onChartClick)
    @$el.find('.chart').html(@template)
    @$el.find('.single-dimension-chart').append(@chartView.render().el)
    @$el.find('.chart-actions').prepend(@sortDropdown.render().el) if @sortDropdown
    @$el.find('.chart-actions').children().last().before(@barMenu.render().el)
    @

  toggleShowQuantity: ->
    @widget.set('show_top_ten', !@widget.get('show_top_ten'))
    @widget.updateWidget()
    @_updateChartData()

  toggleMissingValues: =>
    newState = not @widget.get 'show_missing'
    @widget.set 'show_missing', newState
    @widget.updateWidget()
    @_updateChartData()
    @_renderChart()

  _renderChart: ->
    @chart = @chartView.renderChart()
    @_setChartWidth()
    @barMenu.chart = @chart
    @barMenu.chartView = @
    @chart

  _onChartClick: (elementValue) =>
    @_openDrilldown(elementValue, {})

  _openDrilldown: (drilldownValue, extendedData) ->
    dimension = @widget.get('dimension')
    dimension = "missing_field_#{dimension}" if drilldownValue == @_missingValue()
    data = {
      dimensions: [dimension],
      values: [drilldownValue],
      name: @_drilldownName(drilldownValue),
      definition_code: @widget.get('definition_code'),
      drilldown_code: 'created_conversations',
      timezone: moment().format('Z')
    }
    data = $.extend({}, data, extendedData)
    super(data)

  _setChartWidth: ->
    @chartView.setChartWidth(@)
    @chart?.reflow()

  _changeSorting: (newSortValue) ->
    @widget.set('sorting', newSortValue)
    @widget.updateWidget()
    @_updateChartData()

  toggleMaximize: =>
    @widget.set('is_maximized', !@widget.get('is_maximized'))
    @widget.updateWidget()
    @trigger('masonry')
    @_setChartWidth()

  _getTitle: ->
    return @widget.get('title') unless @widget.canSelectQuantityToShow()
    extra_text = if @widget.get('show_top_ten') && @_totalDataLength() > 10
                   I18n.t('customer_visual_mode.charts.top_ten')
                 else
                   I18n.t('customer_visual_mode.charts.all_results')
    "#{@widget.get('title')} (#{extra_text})"

  _getDescription: ->
    @widget.get('description')

  _updateChartData: ->
    @_updateTitle(@_getTitle())
    @chartView.updateData(@dataFormatter.format(@widget, @data))

  _totalDataLength: ->
    @data.data.length + if @widget.shouldAddMissing(@data) then 1 else 0

  _drilldownName: (drilldownValue) ->
    widgetTranslator = new Common.WidgetDimensionTranslator()
    dimensionName = widgetTranslator.translate(@widget.get('dimension'), {
      attributeName: @_attribute(@session)?.get('name'),
      locale: 'en'
    })
    valueName = if drilldownValue == @_missingValue()
      I18n.t('customer_visual_mode.charts.single_dimension.tickets_without_values', locale: 'en')
    else
      @nameTranslator.name(_.find(@data.data, (item) -> item.name == drilldownValue), {locale: 'en'})
    "#{dimensionName} (#{valueName})"

  _attribute: (session) ->
    session.findAttribute(@widget.get('definition_code'))

  _currentHierarchicalTagCode: ->
    @widget.get('hierarchical_tags_options').code

  _missingValue: ->
    'missing'
